import fields from 'src/store/data/fields.json';
import fieldsEn from 'src/store/data/fields.en.json';
import fieldsSv from 'src/store/data/fields.sv.json';
import fieldsDa from 'src/store/data/fields.da.json';
import fieldsPl from 'src/store/data/fields.pl.json';
import type { FieldViewModel } from './fieldViewModel';
import { currentLanguage } from 'src/i18n';

type FieldOverlay = Record<string, Partial<FieldViewModel>>;

/**
 * Per-språk overlays (issue #13280) som legges over den norske kilden
 * (fields.json). Manglende eller tomme verdier faller tilbake til norsk, så
 * delvise oversettelser er trygge. Norsk (nb) har ingen overlay.
 */
const overlays: Record<string, FieldOverlay> = {
  en: fieldsEn as FieldOverlay,
  sv: fieldsSv as FieldOverlay,
  da: fieldsDa as FieldOverlay,
  pl: fieldsPl as FieldOverlay,
};

export function commonFieldsByCode(): { [key: string]: FieldViewModel } {
  const overlay = overlays[currentLanguage()];
  const result: { [key: string]: FieldViewModel } = {};
  fields.forEach(function (item) {
    if (!overlay) {
      result[item.field] = item;
      return;
    }
    const translation = overlay[item.field];
    result[item.field] = {
      field: item.field,
      label: translation?.label && translation.label.length > 0 ? translation.label : item.label,
      tooltip: translation?.tooltip && translation.tooltip.length > 0 ? translation.tooltip : item.tooltip,
    };
  });
  return result;
}

/**
 * Kan brukes til å sjekke om det fins duplikater i fields
 */
export function duplicateFields() {
  const fieldNames = fields.map((m) => m.field);
  return fieldNames.filter((item, index) => fieldNames.indexOf(item) !== index);
}
